import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from 'api/constants';
import {
  createErrorFromAxiosUserMessageError,
  createErrorFromAxiosMultipleErrors,
} from 'api/utilities';
import UserConcurrentError from 'constants/userConcurrent/error';

export async function updateOutletExpiration(
  event,
  token,
  outletId,
  expirationDate,
  isOnce,
  reason
) {
  const headers = {};
  if (token) {
    headers['X-Token'] = token;
  }
  if (event) {
    headers['X-Event'] = event;
  }

  try {
    return await axios.patch(
      `${BUSINESS_ADMIN_HOST}/v1/outlets/${outletId}/update-subscription`,
      {
        expired_at: expirationDate,
        is_once: isOnce,
        reason,
      },
      {
        headers,
      }
    );
  } catch (e) {
    if (
      [400, 422, 429].includes(e.response.status) &&
      UserConcurrentError.Codes.includes(e.response.data.code)
    ) {
      throw createErrorFromAxiosUserMessageError(e);
    }

    // use token if error response contains token and process still continue
    let additionalInfo = { token: null };
    if (e.response.headers['x-token']) {
      additionalInfo = { token: e.response.headers['x-token'] };
    }

    throw createErrorFromAxiosMultipleErrors(e, additionalInfo);
  }
}

export async function getBulkOutletUpdateLogs(page, size) {
  try {
    return await axios.get(
      `${BUSINESS_ADMIN_HOST}/v1/outlets/update-subscription/logs`,
      {
        params: { page, size },
      }
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}
